class ProductSubscription {
  constructor() {
    this.init();

    /**
     * When loop-w-btn-group-purchase-options-container is available, fetch the first element with a class of "loop-w-btn-group-purchase-option" and inject inner html with: SAVE 48% ON FIRST ORDER
     */
    this.loopWidgetContainer = document.querySelector('.loop-widget-container');
    if (this.loopWidgetContainer) {
      const firstPurchaseOption = this.loopWidgetContainer.querySelector('.loop-w-btn-group-purchase-option');
      if (firstPurchaseOption) {
        firstPurchaseOption.innerHTML = '<div class="loop-w-btn-group-purchase-option-label">SAVE 48% ON FIRST ORDER</div>';
      }
    }
  }

  init() {
    this.initEventListeners();
  }
  
  initEventListeners() {
  }

}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.loop-widget-container')) {
    const productSubscription = new ProductSubscription();
    productSubscription.init();
  }
});
